module.exports = __webpack_public_path__ + "media/images/sp/stores/common/instagram/photographer_sns_02-e6c428479f8a8a2d312a5eb7ae89cc1a.jpg";